import { styled } from '@mui/styles';
import Stack from "@mui/material/Stack";

export const StyledInfoForm = styled(Stack)(({ theme })=>({
    '& .MuiPaper-root': {
        padding: '16px'
    },
    '& .UpdateInfoContainer': {
        padding: 0,
        gap: '32px', 
        display: 'flex', 
        flexDirection: 'column', 
    },
    '& .UpdateInfoContainer .MuiAvatar-root': {
        width: '90px', 
        height: '90px', 
        borderRadius: '12px'
    },
    '& .ProfilePic': {
        '& .MuiIconButton-root': {
            color: 'white'    
        }
    },
    '& .DisplayCurrencyDropdown': {
        height: '55px', 
        borderRadius: '4px', 
        maxWidth: '400px !important',
        border: `1px solid ${theme.palette.neutral.dark}`, 
    }
}));
